import request from "@/utils/request";

export function getCities() {
  return request({
    url: `/api/Cities/GetCities`,
    method: `get`,
  });
}
